import { takeLatest, put, call, take } from "redux-saga/effects";
import {  
    CATEGORY_TICKET_DATA, CATEGORY_TICKET_DATA_GET_API,  
    CATEGORY_SUBCATEGORY_DATA, CATEGORY_SUBCATEGORY_DATA_GET_API,
    CATEGORY_SUBCATEGORY_CONFIG_DATA, CATEGORY_SUBCATEGORY_CONFIG_DATA_GET_API,
    CATEGORY_GET_DATA,CATEGORY_GET_DETAIL_API,
    CATEGORY_FORM_ADD_DATA,CATEGORY_FORM_POST_API,
    CATEGORY_UPDATE_DATA, CATEGORY_POST_API,
    CATEGORY_DELETE_DATA, CATEGORY_DELETE_API,
    CATEGORY_GET_ALL_DATA, CATEGORY_GET_ALL_DATA_API,
    CATEGORY_UPDATE_ALL_DATA, CATEGORY_UPDATE_ALL_API,
    CATEGORY_DELETE_ALL_DATA, CATEGORY_DELETE_ALL_API,
    
} from './Constants'
import {
    setCategoryTicketDataFail, setCategoryTicketDataSuccess,
    setCategorySubCategoryDataFail, setCategorySubCategoryDataSuccess,
    setCategorySubCategoryConfigDataFail, setCategorySubCategoryConfigDataSuccess,
    setCategoryGetDataFail,setCategoryGetDataSuccess,
    setCategoryFormAddDataFail,setCategoryFormAddDataSuccess, 
    setCategoryUpdateDataFail, setCategoryUpdateDataSuccess,  
    setCategoryDeleteDataFail, setCategoryDeleteDataSuccess, 
    setCategoryGetAllDataSuccess, setCategoryGetAllDataFail,
    setCategoryUpdateAllDataSuccess, setCategoryUpdateAllDataFail,loadCategoryGetAllDataRequest,
    setCategoryDeleteAllDataSuccess, setCategoryDeleteAllDataFail,
   
} from './Actions'
import { addErrorAlert, addSuccessAlert } from "../../../alert/Actions";
import { ticketApi} from "../../../../shared/components/Service";

function* getCategoryTicketDataService() {
  try {
    const getCategoryTicketDataResponse = yield call(ticketApi.get, CATEGORY_TICKET_DATA_GET_API);  
    const status = getCategoryTicketDataResponse.status;
    if (status === 200) {
      const data = getCategoryTicketDataResponse.data.data;
      yield put(setCategoryTicketDataSuccess(data));
    } else {
      yield put(setCategoryTicketDataFail(getCategoryTicketDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setCategoryTicketDataFail(error));
  }
}

function* getCategorySubCategoryDataService() {
  try {
    const getCategorySubCategoryDataResponse = yield call(ticketApi.get, CATEGORY_SUBCATEGORY_DATA_GET_API);
    const status = getCategorySubCategoryDataResponse.status;
    if (status === 200) {
      const data = getCategorySubCategoryDataResponse.data.data;
      yield put(setCategorySubCategoryDataSuccess(data));
    } else {
      yield put(setCategorySubCategoryDataFail(getCategorySubCategoryDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setCategorySubCategoryDataFail(error));
  }
}

function* getCategorySubCategoryConfigDataService() {
  try {
    const getCategorySubCategoryConfigDataResponse = yield call(ticketApi.get, CATEGORY_SUBCATEGORY_CONFIG_DATA_GET_API);
    const status = getCategorySubCategoryConfigDataResponse.status;
    if (status === 200) {
      const data = getCategorySubCategoryConfigDataResponse.data.data;
      yield put(setCategorySubCategoryConfigDataSuccess(data));
    } else {
      yield put(setCategorySubCategoryConfigDataFail(getCategorySubCategoryConfigDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setCategorySubCategoryConfigDataFail(error));
  }
}
function* getCategoryGetDataService({ id }) {
  try {
    const getCategoryGetDataResponse = yield call(
      ticketApi.getDetail,
      CATEGORY_GET_DETAIL_API + id
    );
    const status = getCategoryGetDataResponse.status;
    if (status === 200) {
      const newData = getCategoryGetDataResponse.data.data;
      yield put(setCategoryGetDataSuccess(newData));
    } else {
      yield put(setCategoryGetDataFail(getCategoryGetDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setCategoryGetDataFail(error));
  }
}

function* postMyCategoryFormDataService({ request }) {
  try {
    const response = yield call(
      ticketApi.post,
      CATEGORY_FORM_POST_API,
      request
    );

    const status = response?.status;
    const apiData = response?.data || response;

    // SUCCESS → if API returns 200 or 201
    if (status === 200 || status === 201 || apiData?.success) {
      yield put(addSuccessAlert(apiData.msg || "Category Created"));
      yield put(setCategoryFormAddDataSuccess(apiData.data));
      return;
    }

    // FAIL CASE (API returned non-success status)
    yield put(addErrorAlert(apiData.msg || "Error adding Category"));
    yield put(setCategoryFormAddDataFail(apiData.msg));
  } catch (error) {
    // SERVER/NETWORK ERROR
    const msg =
      error?.response?.data?.msg ||
      error?.message ||
      "Error adding Category";

    yield put(addErrorAlert(msg));
    yield put(setCategoryFormAddDataFail(msg));
  }
}

function* postCategoryDataService({ request }) {
    try {
        const response = yield call(ticketApi.put,CATEGORY_POST_API + request.id , request );
        if (response.status === 200) {
            yield put(addSuccessAlert("Category updated"))
            yield put(setCategoryUpdateDataSuccess(response.data.data));
        } else {
            yield put(addErrorAlert(response.response.data.msg))
            yield put(setCategoryUpdateDataFail(response.response.data))
        }
    } catch (error) {
        yield put(addErrorAlert("Could not update Category"))
        yield put(setCategoryUpdateDataFail(error))
    }
}

// delete
function* deleteCategoryDataService({ id }) {
  try {
    const response = yield call(ticketApi.patch, CATEGORY_DELETE_API + id );
    if (response.status === 200) {
      yield put(addSuccessAlert("Category Inactive"))
      yield put(setCategoryDeleteDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.response.data.msg))
      yield put(setCategoryDeleteDataFail(response.response.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Error making Category inactive"))
    yield put(setCategoryDeleteDataFail(error));
  }
}

function* getCategoryAllDataService() {
  try {
    const getCategoryAllDataResponse = yield call(ticketApi.get, CATEGORY_GET_ALL_DATA_API);
    const status = getCategoryAllDataResponse.status;
    if (status === 200) {
      const data = getCategoryAllDataResponse.data.data;
      yield put(setCategoryGetAllDataSuccess(data));
    } else {
      yield put(setCategoryGetAllDataFail(getCategoryAllDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setCategoryGetAllDataFail(error));
  }
}

function* updateCategoryAllDataService({ request }) {
  try {
    const response = yield call(ticketApi.patchRaw, CATEGORY_UPDATE_ALL_API + request.id, { name: request.name });
    if (response.status === 200) {
      // Only show global alert for category, not subcategory (subcategory shows inline)
      if (request.type === "category") {
        yield put(addSuccessAlert(response.data.msg || "Updated successfully"));
      }
      yield put(setCategoryUpdateAllDataSuccess(response.data.data));
      yield put(loadCategoryGetAllDataRequest());
    } else {
      if (request.type === "category") {
        yield put(addErrorAlert(response.response.data.message || "Could not update"));
      }
      yield put(setCategoryUpdateAllDataFail(response.response.data.message || "Could not update"));
    }
  } catch (error) {
    if (request.type === "category") {
      yield put(addErrorAlert(error?.response?.data?.message || "Could not update"));
    }
    yield put(setCategoryUpdateAllDataFail(error?.response?.data?.message || "Could not update"));
  }
}

function* deleteCategoryAllDataService({ id, action, entityType }) {
  try {
    const response = yield call(ticketApi.patchRaw, CATEGORY_DELETE_ALL_API + id + "/" + action);
    if (response.status === 200) {
      if (entityType !== "subcategory") {
        yield put(addSuccessAlert(response.data.msg || "Updated successfully"));
      }
      yield put(setCategoryDeleteAllDataSuccess(response.data.data));
      yield put(loadCategoryGetAllDataRequest());
    } else {
      if (entityType !== "subcategory") {
        yield put(addErrorAlert(response.response.data.message || response.response.data.msg || "Could not update"));
      }
      yield put(setCategoryDeleteAllDataFail(response.response.data.message || "Could not update"));
    }
  } catch (error) {
    if (entityType !== "subcategory") {
      yield put(addErrorAlert(error?.response?.data?.message || "Could not update"));
    }
    yield put(setCategoryDeleteAllDataFail(error?.response?.data?.message || "Could not update"));
  }
}

export function* watchCategories(){
    
    yield takeLatest(CATEGORY_TICKET_DATA.CATEGORY_TICKET_DATA_LOAD, getCategoryTicketDataService);
    yield takeLatest(CATEGORY_SUBCATEGORY_DATA.CATEGORY_SUBCATEGORY_DATA_LOAD, getCategorySubCategoryDataService);
    yield takeLatest(CATEGORY_SUBCATEGORY_CONFIG_DATA.CATEGORY_SUBCATEGORY_CONFIG_DATA_LOAD, getCategorySubCategoryConfigDataService);
    yield takeLatest(CATEGORY_GET_DATA.CATEGORY_GET_DATA_LOAD, getCategoryGetDataService);
    yield takeLatest(CATEGORY_FORM_ADD_DATA.CATEGORY_FORM_ADD_DATA_LOAD, postMyCategoryFormDataService);
    yield takeLatest(CATEGORY_UPDATE_DATA.CATEGORY_UPDATE_DATA_LOAD, postCategoryDataService);
    yield takeLatest(CATEGORY_DELETE_DATA.CATEGORY_DELETE_LOAD, deleteCategoryDataService);
    yield takeLatest(CATEGORY_GET_ALL_DATA.CATEGORY_GET_ALL_DATA_LOAD, getCategoryAllDataService);
    yield takeLatest(CATEGORY_UPDATE_ALL_DATA.CATEGORY_UPDATE_ALL_DATA_LOAD, updateCategoryAllDataService);
    yield takeLatest(CATEGORY_DELETE_ALL_DATA.CATEGORY_DELETE_ALL_LOAD, deleteCategoryAllDataService);
}